<template>
  <div>
    <div v-if="oldperson" style="font-size: 16px;color: #606266;">
      <div style="margin: 0 70px 0 50px">
        <el-row>
          <el-col :span="16">
            <el-row style="height: 35px">
              <el-col :span="12">
                <div class="left-name"><span>姓名：</span></div>
                <div class="right-show-name">
                  <el-input size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.name" placeholder="请输入姓名"></el-input>
                  <span v-else>{{oldperson.name}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="left-name"><span>性别：</span></div>
                <div class="right-show-name">
                  <el-select v-fixZoom size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.sex" placeholder="请选择性别" style="width: 100%">
                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{getSex(oldperson.sex)}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="height: 35px">
              <el-col :span="12">
                <div class="left-name"><span>籍贯：</span></div>
                <div class="right-show-name">
                  <el-input size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.nativeplace" placeholder="请输入籍贯"></el-input>
                  <span v-else>{{oldperson.nativeplace}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="left-name"><span>民族：</span></div>
                <div class="right-show-name">
                  <el-select v-fixZoom size="mini" v-if="isEditMsg || isCallBack" filterable v-model="oldperson.nation" placeholder="请选择民族" style="width: 100%">
                    <el-option v-for="item in nationOptions" :key="item.value" :label="item.value" :value="item.value"></el-option>
                  </el-select>
                  <span v-else>{{oldperson.nation}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="height: 35px">
              <el-col :span="12">
                <div class="left-name"><span>出生日期：</span></div>
                <div class="right-show-name">
                  <el-date-picker v-fixZoom size="mini" v-if="isEditMsg || isCallBack"
                    style="width: 100%" v-model="oldperson.birthday" type="date" value-format="yyyy-MM-dd"
                    placeholder="xxxx-xx-xx" :picker-options="pickerOptions">
                  </el-date-picker>
                  <span v-else>{{oldperson.birthday}}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="left-name"><span>身份证号：</span></div>
                <div class="right-show-name">
                  <el-input size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.idcard_num" placeholder="请输入身份证号"></el-input>
                  <span v-else>{{oldperson.idcard_num}}</span>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="8">
            <div style="width: 90px;margin: auto">
              <img v-if="oldperson.photourl !== ''" :src="oldperson.photourl" class="avatar">
              <img v-else src="/static/mapIcon/index_popup_img2.png" class="avatar">
            </div>
          </el-col>
        </el-row>
        <div style="height: 35px">
          <div class="left-name"><span>身份证地址：</span></div>
          <div class="right-show-name">
            <el-input size="mini" v-if="isEditMsg || isCallBack" placeholder="请输入地址" v-model="oldperson.idcard_address"></el-input>
            <span v-else>{{oldperson.idcard_address}}</span>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div v-if="isEditMsg || isCallBack" style="height: 1px;background-color: #ebebeb;margin: 10px 0"></div>
      <div v-else style="height: 1px;background-color: #ebebeb;"></div>
      <div style="margin: 0 70px 0 50px">
        <el-row style="height: 35px">
          <el-col :span="8">
            <div class="left-name"><span>联系方式：</span></div>
            <div class="right-show-name">
              <el-input size="mini" v-if="isEditMsg || isCallBack" type="number" v-model="oldperson.phone" placeholder="请输入联系方式"></el-input>
              <span v-else>{{oldperson.phone}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="left-name"><span>血型：</span></div>
            <div class="right-show-name">
              <el-select v-fixZoom size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.blood_type" placeholder="请选择" style="width: 100%">
                <el-option v-for="item in bloodTypes" :key="item.value" :label="item.name" :value="item.value"> </el-option>
              </el-select>
              <span v-else>{{getBloodTypeName(oldperson.blood_type)}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="left-name"><span>健康状况：</span></div>
            <div class="right-show-name" v-if="isEditMsg || isCallBack">
              <div v-if="isHealth === 0" style="width: calc(100% - 75px);float: left">
                <el-select v-fixZoom size="mini" v-model="isHealth" placeholder="请选择" style="width: 100%" @change="changeHealth">
                  <el-option v-for="item in healthOptions" :key="item.value" :label="item.name" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div v-else style="width: 100%">
                <el-select v-fixZoom size="mini" v-model="isHealth" placeholder="请选择" style="width: 100%" @change="changeHealth">
                  <el-option v-for="item in healthOptions" :key="item.value" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </div>
              <div v-if="isHealth === 0" style="width: 75px;float: right;text-align: right">
                <el-button size="mini" v-if="isHealth === 0" type="primary" plain @click="seeDisease()">查看</el-button>
              </div>
            </div>
            <div class="right-show-name" v-else>
              <span v-if="isHealth === 1">健康</span>
              <span v-else>患病</span>
              <el-button size="mini" v-if="isHealth === 0" type="primary" plain @click="seeDisease()">查看</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row style="height: 35px">
          <el-col :span="8">
            <div class="left-name"><span>服务频率：</span></div>
            <div class="right-show-name">
              <el-select v-fixZoom size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.frequencyid" filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in frequencys" :key="item.value" :label="item.frequency" :value="item.id"></el-option>
              </el-select>
              <span v-else>{{getFrequencyName(oldperson.frequencyid)}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="left-name"><span>所属项目：</span></div>
            <div class="right-show-name">
<!--              <el-select v-fixZoom size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.projectid" filterable placeholder="请选择" style="width: 100%">-->
<!--                <el-option v-for="item in projects" :key="item.value" :label="item.projectname" :value="item.id"></el-option>-->
<!--              </el-select>-->
              <el-select v-fixZoom size="mini" v-if="isEditMsg || isCallBack" v-model="oldperson.projectids" multiple collapse-tags style="width: 100%" placeholder="请选择" @change="changeProject">
                <el-option v-for="item in projects" :key="item.value" :label="item.projectname" :value="item.id">
                </el-option>
              </el-select>
              <span v-else>{{getProjectName(oldperson.projectid)}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="left-name"><span>接听时间段：</span></div>
            <div class="right-show-name">
               <el-time-picker v-fixZoom size="mini" v-if="isEditMsg || isCallBack"
                style="width: 100%" is-range v-model="timechange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                placeholder="选择时间范围" value-format="HH:mm" @change="changeTime">
              </el-time-picker>
              <span v-else>{{oldperson.timelist}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="height: 35px">
          <el-col :span="8">
            <div class="left-name"><span>特殊情况：</span></div>
            <div class="right-show-name">
              <el-input size="mini" v-if="isEditMsg || isCallBack" placeholder="例：失独，离异，丧偶等"
                v-model="oldperson.circumstances">
              </el-input>
              <span v-else>{{oldperson.circumstances}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="left-name"><span>生命体征：</span></div>
            <div class="right-show-name"  v-if="oldperson.is_dead === 1"><span v-if="oldperson.is_dead === 1">离世 {{oldperson.dead_time}}</span></div>
            <div class="right-show-name" v-else-if="isEditMsg || isCallBack">
              <el-select v-fixZoom size="mini" v-model="oldperson.is_dead" filterable placeholder="请选择" style="width: 100%" @change="changeDead">
                <el-option v-for="item in deadArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="right-show-name" v-else><span v-if="oldperson.is_dead === 0">在世</span><span v-if="oldperson.is_dead === 1">离世{{oldperson.dead_time}}</span></div>
          </el-col>
          <el-col :span="8" v-if="isDead">
            <div class="left-name"><span>离世时间：</span></div>
            <div class="right-show-name">
              <el-date-picker v-fixZoom value-format="yyyy-MM-dd" size="mini" style="width: 100%" :clearable="false" v-model="oldperson.dead_time" type="date" placeholder="选择日期"></el-date-picker>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="isEditMsg || isCallBack" style="height: 1px;background-color: #ebebeb;margin: 10px 0"></div>
      <div v-else style="height: 1px;background-color: #ebebeb;"></div>
      <div v-if="isCallBack" style="height: 10px"></div>
      <div style="margin: 0 70px 0 50px">
        <el-row style="height: 35px">
          <el-col :span="8">
            <div class="left-name">
              <span>所属区域：</span>
            </div>
            <div class="right-show-name all-three-point" :title="oldperson.orglevelname">
              <span>{{oldperson.orglevelname}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="left-name">
              <span>{{isLabel}}：</span>
            </div>
            <div class="right-show-name all-three-point" :title="oldperson.h_address">
              <span>{{oldperson.h_address}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div style="float: right" v-if="isCallBack">
              <div class="send-btn" @click="checkCommit()"><span>提交审核</span></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-if="isCallBack" style="height: 10px"></div>
      <div v-if="isEditMsg" style="height: 1px;background-color: #ebebeb;"></div>
      <div style="margin-top: 15px" v-if="isEditMsg">
        <div class="send-btn" @click="checkCommit()"><span>提交审核</span></div>
      </div>
    </div>
    <div v-else style="text-align: center;height: 120px;line-height: 120px;font-size: 20px">
      <span>暂无人员信息</span>
    </div>
    <!--患病情况-->
    <el-dialog width="600px" :visible.sync="diseaseShow" v-if="diseaseShow" :close-on-click-modal="false"
      center append-to-body class="all-open" :show-close="isShow">
      <disease-select v-model="diseaseShow" :diseaseObj="diseaseObj" @changeDiseaseObj="changeDiseaseObj"></disease-select>
    </el-dialog>
  </div>
</template>

<script>
import {querydiseasename} from '../../../api/home'
import {addcheckinfo} from '../../../api/serviceObject'
import diseaseSelect from './diseaseSelect'
export default {
  name: 'serviceObjectAlarm',
  components: {diseaseSelect},
  props: {
    serviceObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isEditMsg: false,
      sexOptions: [{name: '男', value: 1}, {name: '女', value: 0}],
      nationOptions: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      healthOptions: [{name: '健康', value: 1}, {name: '患病', value: 0}],
      diseasesnew: [],
      selectdiseasesids: [],
      isLabel: '所属家庭/机构：',
      isCenterName: '请选择小区',
      isRightName: '请选择已有家庭',
      homeAddress: '',
      oldperson: {
        id: 0,
        name: '',
        birthday: '',
        sex: '',
        phone: '',
        frequencyid: '',
        projectid: '',
        projectids: [],
        circumstances: '',
        timelist: '',
        homeid: '',
        photoid: 0,
        nation: '',
        nativeplace: '',
        idcard_num: '',
        idcard_address: '',
        blood_type: '',
        have_disease: '',
        dead_time: '',
        input_disease: ''
      },
      photourl: '',
      isHealth: '',
      timechange: ['', ''],
      moduletag: '',
      projects: [],
      frequencys: [],
      diseaseShow: false,
      diseasenames: [],
      diseaseids: [],
      bloodTypes: [
        {name: 'A型', value: 1},
        {name: 'B型', value: 2},
        {name: 'AB型', value: 3},
        {name: 'O型', value: 4},
        {name: 'A-型', value: 5},
        {name: 'B-型', value: 6},
        {name: 'AB-型', value: 7},
        {name: 'O-型', value: 8}
      ],
      // 客服关爱
      isCallBack: false,
      deadArr: [{id: 0, name: '在世'}, {id: 1, name: '离世'}],
      isDead: false, // 是否已离世
      diseaseObj: {
        isEditMsg: false,
        isCallBack: false,
        diseasenames: [],
        diseasesnew: [],
        selectdiseasesids: [],
        diseaseids: [],
        input_disease: ''
      },
      isShow: false
    }
  },
  created () {
    /* 1、doHandleAlarm.vue事件处理页面 处理弹窗 2、callPhonePage.vue 客服关爱页面 呼叫弹窗 3、alarmDetailsNew.vue 事件/服务统计页面 查看弹窗 */
    this.getStartPerson()
  },
  methods: {
    changePerson (obj) {
      this.serviceObj = obj
      this.isShow = true // 视频页面 只能看 videoZg.vue
      this.getStartPerson()
    },
    // 开始
    getStartPerson () {
      if (this.serviceObj.isEdit && this.$store.state.user.customerservicetag === 1) { // 事件处理弹窗
        this.isEditMsg = true
        this.oldperson = this.serviceObj.editOldPerson
      } else {
        if (this.serviceObj.isCallBack) { // 客服关爱
          this.oldperson = this.serviceObj.editOldPerson
        } else {
          this.oldperson = this.serviceObj.oldperson
        }
      }
      this.nationOptions = this.commonType.getNationName()
      if (this.serviceObj.isCallBack) {
        this.isCallBack = true
      }
      this.getDisease()
      // console.log(this.oldperson)
      if (this.oldperson && this.oldperson.timelist && this.oldperson.timelist !== '') {
        let date = this.oldperson.timelist.split('~')
        this.timechange = [date[0], date[1]]
      }
      this.projects = this.serviceObj.projects
      this.frequencys = this.serviceObj.frequencys
      this.moduletag = this.$store.state.user.moduletag
      if (this.moduletag === 1) {
        this.isLabel = '所属家庭'
      } else if (this.moduletag === 2) {
        this.isLabel = '所属房间'
      } else {
        this.isLabel = '家庭/房间'
      }
      if (this.oldperson) {
        if (this.oldperson.have_disease === '') {
          if (this.oldperson.input_disease !== '') {
            this.isHealth = 0 // '其他患病'
          } else {
            this.isHealth = 1 // '健康'
          }
        } else {
          let arr = this.oldperson.have_disease.split(',')
          this.diseaseids = arr
          this.selectdiseasesids = []
          for (let i = 0; i < arr.length; i++) {
            this.selectdiseasesids.push(parseInt(arr[i]))
          }
          this.diseaseObj.diseaseids = arr
          this.diseaseObj.selectdiseasesids = this.selectdiseasesids
          // console.log('患病', arr)
          this.isHealth = 0 // '患病'
        }
        this.diseaseObj.input_disease = this.oldperson.input_disease
      }
      this.diseaseObj.isEditMsg = this.isEditMsg
      this.diseaseObj.isCallBack = this.isCallBack
    },
    // 离世
    changeDead () {
      if (this.oldperson.is_dead === 1) {
        this.isDead = true
      } else {
        this.isDead = false
      }
    },
    // 患病
    changeHealth (id) {
      if (id === 0) {
        this.diseaseShow = true
      }
    },
    changeTime (val) {
      if (val.length > 0) {
        this.oldperson.timelist = val[0] + '~' + val[1]
      } else {
        this.oldperson.timelist = ''
      }
    },
    // 提交审核
    checkCommit () {
      if (this.isHealth === 1) {
        this.oldperson.have_disease = ''
        this.oldperson.input_disease = ''
      }
      let changeinfo = {
        homeinfo: '',
        personinfo: this.oldperson
      }
      let data = {
        hid: this.oldperson.homeid,
        pid: this.oldperson.id,
        changeinfo: JSON.stringify(changeinfo)
      }
      if (this.oldperson.is_dead === 1 && this.oldperson.dead_time === '') {
        this.$message({
          message: '请选择离世时间。',
          type: 'warning'
        })
        return
      }
      // console.log(999, this.serviceObj.oldperson, changeinfo)
      addcheckinfo(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功提交审核',
          type: 'success',
          duration: 2000
        })
        this.$emit('handleAlarm', this.oldperson)
      }).catch(() => {})
      // this.$emit('handleAlarm', this.oldperson)
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    changeProject () {
      if (this.oldperson.projectids.length > 0) {
        this.oldperson.projectid = this.oldperson.projectids[this.oldperson.projectids.length - 1]
      }
    },
    getProjectName (id) {
      for (let i = 0; i < this.projects.length; i++) {
        if (id === this.projects[i].id) {
          return this.projects[i].projectname
        }
      }
    },
    getFrequencyName (id) {
      for (let i = 0; i < this.frequencys.length; i++) {
        if (id === this.frequencys[i].id) {
          return this.frequencys[i].frequency
        }
      }
    },
    // 患病类型
    getDisease () {
      querydiseasename().then(res => {
        this.diseasenames = res.data.diseasenames
        this.diseasesnew = this.commonType.getDisease(this.diseasenames)
        this.diseaseObj.diseasenames = res.data.diseasenames
        this.diseaseObj.diseasesnew = this.commonType.getDisease(this.diseasenames)
      }).catch(() => {})
    },
    getDiseaseName (id) {
      // console.log(id)
      for (let i = 0; i < this.diseasenames.length; i++) {
        if (parseInt(id) === this.diseasenames[i].id) {
          return this.diseasenames[i].name
        }
      }
    },
    seeDisease () {
      let arr = this.oldperson.have_disease.split(',')
      this.selectdiseasesids = []
      // console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        this.selectdiseasesids.push(parseInt(arr[i]))
      }
      this.diseaseShow = true
    },
    closeOpen1 () {
      if (this.oldperson.have_disease === '') {
        this.isHealth = 1
        this.selectdiseasesids = []
      } else {
        this.isHealth = 0
      }
      this.diseaseShow = false
    },
    submit1 () {
      let ids = this.selectdiseasesids
      let aa = ids[0] + ''
      for (let i = 1; i < ids.length; i++) {
        aa = aa + ',' + ids[i]
      }
      this.oldperson.have_disease = aa
      this.diseaseShow = false
    },
    // 弹窗患病选择
    changeDiseaseObj (obj) {
      this.oldperson.have_disease = obj.have_disease
      this.oldperson.input_disease = obj.input_disease
      this.diseaseShow = false
    },
    getBloodTypeName (val) {
      for (let i = 0; i < this.bloodTypes.length; i++) {
        if (val === this.bloodTypes[i].value) {
          return this.bloodTypes[i].name
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/handlealarm/childComponents/serviceObjectAlarm.vue